import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4070175448/src/apps/fanychance/src/features/lottery/components/LotteryInfiniteList/LotteryInfiniteList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4070175448/src/apps/fanychance/src/features/lottery/components/LotteryListHeader/LotteryListHeader.tsx");
